export default __webpack_public_path__ + "static/media/g-dragon-logo-sq.618a0ffd.png";